import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Products from '../components/Products';
import Catering from '../components/Catering';
import Retailers from '../components/Retailers';
import Story from '../components/Story';
import Footer from '../components/Footer';

const Home = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`home-container ${isLoaded ? 'loaded' : ''}`}>
      <Header />
      <Hero />
      <Products />
      <Catering />
      <Retailers />
      <Story />
      <Footer />
    </div>
  );
};

export default Home;
